import password_rejected from './password-rejected.js';
const error = {
    general_required: `{{types, list(type: disjunction;)}} este obligatoriu`,
    general_invalid: `{{types, list(type: disjunction;)}} este invalid`,
    username_required: 'Numele de utilizator este obligatoriu',
    password_required: 'Parola este obligatorie',
    username_exists: 'Numele de utilizator există deja',
    username_should_not_start_with_number: 'Numele de utilizator nu trebuie să înceapă cu un număr',
    username_invalid_charset: 'Numele de utilizator trebuie să conțină doar litere, cifre sau caractere de subliniere.',
    invalid_email: 'Adresa de e-mail este invalidă',
    invalid_phone: 'Numărul de telefon este invalid',
    passwords_do_not_match: 'Parolele nu se potrivesc. Vă rugăm să încercați din nou.',
    invalid_passcode: 'Codul de verificare este invalid.',
    invalid_connector_auth: 'Autorizarea este invalidă',
    invalid_connector_request: 'Datele conectorului sunt invalide',
    unknown: 'Eroare necunoscută. Vă rugăm să încercați din nou mai târziu.',
    invalid_session: 'Sesiune negăsită. Vă rugăm să reveniți și să vă autentificați din nou.',
    timeout: 'Timpul de așteptare a expirat. Vă rugăm să încercați din nou mai târziu.',
    password_rejected,
    sso_not_enabled: 'Autentificarea unică (Single Sign-On) nu este activată pentru acest cont de e-mail.',
};
export default Object.freeze(error);
